export default "<div class=\"conteneur\">\n  {{ConteneurInComponent}}\n</div>\n\n";